module.exports = __webpack_public_path__ + "static/media/logouticon.3d2184f9.svg";